var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81818 0H18.1818C19.1864 0 20 0.813636 20 1.81818V18.1818C20 19.1864 19.1864 20 18.1818 20H1.81818C0.813636 20 0 19.1864 0 18.1818V1.81818C0 0.813636 0.813636 0 1.81818 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81818 0C0.813636 0 0 0.813636 0 1.81818V18.1818C0 19.1864 0.813636 20 1.81818 20H18.1818C19.1864 20 20 19.1864 20 18.1818V1.81818C20 0.813636 19.1864 0 18.1818 0H1.81818ZM4.22585 4.54545H8.41797L10.8647 8.04332L13.892 4.54545H15.2113L11.4577 8.89205L16.0494 15.4545H11.8572L9.1424 11.5732L5.79013 15.4545H4.44957L8.54581 10.7227L4.22585 4.54545ZM6.25355 5.62145L12.3935 14.3732H14.0199L7.8782 5.62145H6.25355Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ed0cc19b91f0381ebfb78cc611aee364.svg";
export { ForwardRef as ReactComponent };